import React, { useMemo } from 'react';

import { COUNTRY_LANGUAGE_MAP, SUPPORTED_COUNTRIES, SUPPORTED_STATES, SUPPORTED_CITIES,  } from "../data/langData";

const CountryStateCityPicker = ({
  value = {},
  onChange,
  supportedCountries = SUPPORTED_COUNTRIES,
  supportedStates = SUPPORTED_STATES,
  supportedCities = SUPPORTED_CITIES,
  onLanguageDetect,
}) => {
  // Derive options directly, no need for useState or useEffect
  const stateOptions = useMemo(
    () => supportedStates[value.country] || [],
    [value.country, supportedStates]
  );

  const cityOptions = useMemo(
    () => supportedCities[value.state] || [],
    [value.state, supportedCities]
  );

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     onChange(name, value);
//   };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === 'country' && onLanguageDetect) {
      // A simple mock mapping. You can expand this list as needed.
  
      const detectedLang = COUNTRY_LANGUAGE_MAP[name];
      if (detectedLang) {
        onLanguageDetect(detectedLang);
      }
    }
  
    onChange(name, value);
  };

  return (
    <div className="row my-3">
      {/* Country */}
      <div className="col-md-4 my-1">
        <div className="form-floating form-section-col">
          <input
            list="countries"
            name="country"
            className="form-control border-0"
            placeholder="Country"
            value={value.country || ''}
            onChange={handleInputChange}
            required
          />
          <label htmlFor="country">Country</label>
          <datalist id="countries">
            {supportedCountries.map((c) => (
              <option key={c} value={c} />
            ))}
          </datalist>
        </div>
      </div>

      {/* State */}
      <div className="col-md-4 my-1">
        <div className="form-floating form-section-col">
          <input
            list="states"
            name="state"
            className="form-control border-0"
            placeholder="State/Region"
            value={value.state || ''}
            onChange={handleInputChange}
            required
          />
          <label htmlFor="state">State/Region</label>
          <datalist id="states">
            {stateOptions.map((s) => (
              <option key={s} value={s} />
            ))}
          </datalist>
        </div>
      </div>

      {/* City */}
      <div className="col-md-4 my-1">
        <div className="form-floating form-section-col">
          <input
            list="cities"
            name="city"
            className="form-control border-0"
            placeholder="City"
            value={value.city || ''}
            onChange={handleInputChange}
            required
          />
          <label htmlFor="city">City</label>
          <datalist id="cities">
            {cityOptions.map((c) => (
              <option key={c} value={c} />
            ))}
          </datalist>
        </div>
      </div>
    </div>
  );
};

export default CountryStateCityPicker;
